// extracted by mini-css-extract-plugin
export default {"upload_image_container":"ImageInput_upload_image_container__eoKki","upload_image":"ImageInput_upload_image__kBt7U","label":"ImageInput_label__BSAnI"};